import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MarketSelectionComponent } from './market-selection.component';

@NgModule({
  declarations: [MarketSelectionComponent],
  imports: [CommonModule],
})
export class MarketSelectionModule {}
